export default __webpack_public_path__ + "static/spanish-online-banner-4c52831ff8819c147a49734b1d2fe9dc.svg";